import PropTypes from 'prop-types';
import React from 'react';
import { makeStyles } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { StyledChartRangeItem2 } from '~/modules/common/charts/timeline/components';

const useStyles = makeStyles(theme => ({
  root: {
    height: theme.spacing(3)
  },
  timeContainer: {
    minHeight: 0
  }
}));

const useHeaderStyles = makeStyles(theme => ({
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing(2),
    ...theme.typography.caption,
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.secondary
  }
}));

export const UserTaskAssignmentHeaderRow = ({
  classes: classesOverrides,
  leftComponentWidth,
  scale,
  scaleItemCount,
  chartStartDate
}) => {
  const classes = useStyles({ classes: classesOverrides });
  const headerClasses = useHeaderStyles();

  return (
    <StyledChartRangeItem2
      classes={classes}
      scale={scale}
      scaleItemCount={scaleItemCount}
      leftComponentWidth={leftComponentWidth}
      chartStartDate={chartStartDate}
    >
      <div className={headerClasses.headerContainer}>
        <FormattedMessage id="taskAssignments.header" />
      </div>
      <div />
      <div />
    </StyledChartRangeItem2>
  );
};

UserTaskAssignmentHeaderRow.propTypes = {
  classes: PropTypes.object,
  scale: PropTypes.string.isRequired,
  scaleItemCount: PropTypes.number.isRequired,
  leftComponentWidth: PropTypes.number,
  chartStartDate: PropTypes.object
};

export default UserTaskAssignmentHeaderRow;
